import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalSelector from "./ModalSelector";
import DataTable from "../Tables/DataTable";
import { useComunidades } from "../../hooks";
import { Typography, Box, TextField } from "@mui/material";
import { Iconify } from "../../utilities";
import LaeButton from "../Buttons/LaeButton";
import { toast } from "react-toastify";

const PropertieSelector = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { loading, data, fetchData } = useComunidades();
  const [search, setSearch] = useState({});

  const headers = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
    },
    {
      id: "community",
      numeric: false,
      disablePadding: false,
      label: t('properties:titleSingular'),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('properties:fields.nif'),
    },
  ];

  const handleSelect = (row) => {
    if (row && !row.isWorkcenter && row.centrosTrabajo?.length > 0) {
      toast.info(t('properties:messages.selectWorkcenter'));
      return;
    }
    onClose({data:row});
  };

  const handleFetchData = async ({offset, limit}) => {
    try {
      for (let key in search) {
        if (
          search[key] === "" ||
          search[key] === null ||
          search[key] === undefined
        ) {
          delete search[key];
        }
      }
      // console.log(search)
      const filtros = { razonSocial: search.razonSocial, nif: search.nif };
    
      await fetchData({ offset, limit, filtros});
    } catch (error) {
      console.log(error);
    }
  };

  function handleChange(evt) {
    const value = evt.target.value;

    setSearch({
      ...search,
      [evt.target.name]: value,
    });
  }

  return (
    <ModalSelector
      open={open}
      onClose={onClose}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        p: 2,
        pt: 8,
        gap: 5,
        alignItems: "center",
      }}
    >
      <Box
        sx={{ position: "absolute", right: 10, top: 5 }}
        onClick={() => handleSelect()}
      >
        <Iconify icon="mdi:close" sx={{ height: 24, width: 24 }} />
      </Box>
      <Typography variant="h4">{t('properties:select')}</Typography>
      <DataTable
        data={data?.rows}
        meta={data?.meta}
        isLoading={loading}
        headers={headers}
        onClickRow={handleSelect}
        fetcher={handleFetchData}
        currentPage={data?.current_page}
        clicable
      >
        <Box
          m={2}
          display={"flex"}
          flexDirection={"row"}
          width={"100%"}
          gap={2}
        >
          <TextField
            id="razonSocial-input"
            label={t('aaff:fields.name')}
            name="razonSocial"
            variant="outlined"
            value={search.razonSocial}
            onChange={handleChange}
            inputProps={{
              "aria-label": "controlled",
            }}
          />
          <TextField
            id="nif-input"
            label={t('properties:fields.nif')}
            name="nif"
            variant="outlined"
            value={search.nif}
            onChange={handleChange}
            inputProps={{
              "aria-label": "controlled",
            }}
          />
          <LaeButton onClick={handleFetchData} sx={{ width: 100 }}>
            <Typography>{t('common:actions.search')}</Typography>
          </LaeButton>
        </Box>
      </DataTable>
    </ModalSelector>
  );
};

export default PropertieSelector;
